export var WorkflowConfigurationUrls = {
    getWorkflowConfigurations: "WorkflowConfiguration/GetWorkflowConfigurations",
    getActivityMetadata: "WorkflowConfiguration/GetActivityMetadata",
    getWorkflowConfiguration: "WorkflowConfiguration/GetWorkflowConfiguration",
    saveWorkflowConfiguration: "WorkflowConfiguration/SaveWorkflowConfiguration",
    deleteWorkflowConfiguration: "WorkflowConfiguration/DeleteWorkflowConfiguration",
    accept: "WorkflowConfiguration/Accept",
    getEntityTypesForWorkflow: "WorkflowConfiguration/GetEntityTypesForWorkflow"
};
